import React, { useState,useEffect } from 'react';
import { Country, State, City }  from 'country-state-city';
import styled from 'styled-components';
import { useAuthStore } from '../store/store';
import { NavLink, useNavigate } from 'react-router-dom';
import {toast , Toaster } from 'react-hot-toast';
import UserMenu from './UserMenu';
import AddressForm from './AddressForm';
import PageHeader from "../components/PageCloseButton";
import {toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";

const CreateAddress = () => {

  const [countries]=useState(Country.getAllCountries());
  const [states,setStates]=useState([]);
  const [cities, setCities]=useState([]);
  
  const [selectedCountry, setSelectedCountry]=useState(null);
  const [selectedState, setSelectedState]=useState(null);
     
         

  const { auth } = useAuthStore();
  const navigate=useNavigate();
    //  const user = auth?.profile;          //   make sure this matches your store shape
      const isLoggedIn = auth?.isLoggedIn;
      const [formAddress, setFormAddress] = useState({
    name: "",
    street_add: "",
    city: "",
    state_province: "",
    country: "",
    zipcode: "",
    phone: "",
    isdCode: ""
  });
// =========Country Change==================================================
 const handleCountryChange = (country)=>{
  if (!country) return;
           setSelectedCountry(country);
           setStates(State.getStatesOfCountry(country.isoCode));
           setCities([]);

           setFormAddress((prev) => ({
      ...prev,
      country: country.name, 
      isdCode: country.phonecode,// Store country code
      state_province: '',
      city: '',
    }));
    console.log("Selected:", country.name, "ISD:", country.phonecode);
         };
         
//===========state change====================================================
const handleStateChange = (state)=>{
           setSelectedState(state);
           setCities(City.getCitiesOfState(selectedCountry.isoCode, state.isoCode));  
           
           
           setFormAddress((prev) => ({
      ...prev,
      state_province: state.name, // Store state code
      city: '',
    }));
         };
     
  const [addresses] = useState([]); // NEW: store list of addresses
  const [setSelectedAddress] = useState(null);

// handle Change===============================
 const handleChange = (e) => {
    const { id, value } = e.target;
    setFormAddress((prev) => ({
      ...prev,
      [id]: toTitleCase(value),
    }));
  };

//=====handle Submit==================================
const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting address:", formAddress);
    toast.success('Address added successfully');

    try {
      const token = auth?.token; // ✅ Include token for auth
      
      const response = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/address`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ Added
        },
        body: JSON.stringify(formAddress),
      });

      if (!response.ok) {
        toast.error('Address cannot be added');
        throw new Error('Address creation failed');
      }

      
      // Reset form
      setFormAddress({
        name: '',
        street_add: '',
        city: '',
        state_province: '',
        zipcode: '',
        country: '',
        phone: '',
        isdCode: '', 
      });
    }

     catch (error) {
      toast.error("Failed to add address");
    }
  };

  //handle selected address
 const handleAddress = (index) => {
    const chosen = addresses[index];
    setSelectedAddress(chosen);
    setFormAddress(chosen); // populate form with selected address

     const countryObj = Country.getAllCountries().find(
    (c) => c.name === chosen.country
  );

  if (countryObj) {
    setSelectedCountry(countryObj);
    setStates(State.getStatesOfCountry(countryObj.isoCode));

    // ✅ Step 2: Find state object
    const stateObj = State.getStatesOfCountry(countryObj.isoCode).find(
      (s) => s.name === chosen.state_province
    );

    if (stateObj) {
      setSelectedState(stateObj);
      setCities(City.getCitiesOfState(countryObj.name, stateObj.name));
    }
  }
  };
  // ---------------- RESET ----------------

  const handleReset = () => {

    setFormAddress({
      name: auth?.user?.username || "",
      street_add: "",
      city: "",
      state_province: "",
      country: "",
      zipcode: "",
      phone: "",
      isdCode: '', 
    });

    setSelectedCountry(null);
    setSelectedState(null);
    setStates([]);
    setCities([]);
  };



    return (
    <Wrapper>
       <Toaster position="top-right" reverseOrder={false} />
        <div className="grid grid-two-column">
          <UserMenu/>
            <div class="address-container" > 
               <PageHeader title="Create Address" />                 
              <form autoComplete="off" onSubmit={handleSubmit}>            
                    <AddressForm 
                      formAddress={formAddress}
                      setFormAddress={setFormAddress}
                      handleChange={handleChange}
                      handleCountryChange={handleCountryChange}
                      handleStateChange={handleStateChange}
                      handleSubmit={handleSubmit}
                      handleReset={handleReset}
                      countries={countries}
                      states={states}
                      cities={cities}
                      selectedCountry={selectedCountry}
                      selectedState={selectedState}
                      auth={auth}
                      submitLabel="Submit"
                      />                  
                  </form>
                </div> 
          </div>           
    </Wrapper>
  )
}


 const Wrapper = styled.section`
  .grid-two-column {
    display: grid;
    grid-template-columns: 2fr 8fr;
    gap: 2rem;
    }

  .address-container{    
    width: 40%;
    margin: 3rem auto; 
    border-radius: 0.8rem;
    background: ${({ theme }) => theme.colors.bg};
    box-shadow: 0 2px 10px rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;  
    padding: 1rem; 
    }

 @media (max-width: ${({ theme }) => theme.media.mobile}){
  
 .grid-two-column {
      grid-template-columns: 1fr;
      }

 .address-container {
    width: 95%;
    margin: 2rem auto;
    }

  }
 `;

export default CreateAddress;